"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css/bundle";

import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import { observeElementIntersection } from "@/lib/utils/util";
import React from "react";
const LoadNormalModal = React.lazy(() => import("@/components/3DNormalModal"));
const spaceBetween = 0;
const slidesPerView = 1;

type CardType = {
	title: string;
	desc: string;
	desc2?: string;
	desc3?: string;
	link: string;
	style?: React.CSSProperties; // 用于传递内联样式
	setHover?: any;
	hover?: boolean;
};

const Card = ({
	title,
	desc,
	desc2,
	desc3,
	link,
	setHover,
	hover,

	style = {}, // 默认样式为空
}: CardType) => {
	const t = useTranslations("banner");

	useEffect(() => {
		observeElementIntersection(
			".home-banner .animate",
			(target) => {
				if (window.innerWidth <= 768) return;
				if (target.classList.contains("banner-box")) {
					target.classList.remove("opacity-0");
					target.classList.add("animate__fadeIn");
				} else {
					target.classList.add("animate__fadeInLeft");
				}
			},
			(target) => {
				if (window.innerWidth <= 768) return;
				if (target.classList.contains("banner-box")) {
					target.classList.remove("animate__fadeIn");
					target.classList.add("opacity-0");
				} else {
					target.classList.remove("animate__fadeInLeft");
				}
			},
		);
	}, []);
	return (
		<div className={`absolute inset-0 z-[3] bg-transparent `} style={style}>
			<div className="container flex h-full w-full items-center 2xl:items-start">
				<div className="home-banner flex w-full md:ml-[0px] lg:ml-[-60px] lg:mt-[-100px] xl:ml-[-60px] xl:mt-[-100px] 2xl:ml-[-120px] 2xl:mt-[300px]">
					{/* font-serif */}
					<div className="animate animate__animated banner-box animate__delay-300 max-w-[600px] md:ml-[80px] lg:ml-[120px] xl:ml-[180px] 2xl:ml-[220px]">
						<h2 className="animate__animated animate animate__delay-800 text-shadow-md py-1 text-white max-md:hidden md:text-[30px] md:leading-[32px] lg:text-[40px] lg:leading-[40px] xl:text-[50px] xl:leading-[50px] 2xl:text-[60px] 2xl:leading-[60px]">
							{t("hb1")}
							<br /> {t("hb2")}
						</h2>
						<h2 className="bannerBtn animate__animated animate animate__delay-1000 !mb-[4px] py-1.5 font-light text-white max-md:hidden md:text-[14px] lg:text-[16px] xl:text-[18px] 2xl:text-[20px]">
							{t("hb3")}
						</h2>
						<Link
							href={"/products"}
							className="bannerBtn animate animate__animated animate__delay-1500 mt-8 block w-fit border-[1px] border-white bg-opacity-0 px-4 py-2 text-white duration-300 hover:!text-gray-300 max-md:hidden md:mt-3 md:text-[16px] lg:mt-4 lg:text-[18px] xl:mt-6 xl:text-[20px] 2xl:mt-8 2xl:text-[22px]"
						>
							{t("Show More")}
						</Link>
					</div>
					{/* <div className="ml-[300px] flex ">
						<LoadNormalModal
							setHover={setHover}
							modalUrl={"/stary3D/" + "xinghe-1000w-6-4us.glb"} // 传递 ArrayBuffer 给 View3DModal
							className={`mb-[300px] ml-[300px]  !h-[380px] !w-[500px] rounded-lg  max-2xl:ml-[200px] max-xl:ml-[50px] max-md:!h-[450px]`}
							fileName={"xinghe-1000w-6-4us.glb"}
							metalness={0.8}
							roughness={0.2}
							color={"#161417"}
						/>
						<div className="mt-[230px]  ">
							<img src="/image/home/3dmark.svg" className="fill-opacity=0.5 h-[35px] w-[35px]" alt="" />
						</div>
					</div> */}
				</div>
			</div>
		</div>
	);
};

const Card2 = ({
	title,
	desc,
	link,
	desc2,
	desc3,
	setHover,
	hover,

	style = {}, // 默认样式为空
}: CardType) => {
	const t = useTranslations("banner");

	useEffect(() => {
		observeElementIntersection(
			".home-banner .animate",
			(target) => {
				if (window.innerWidth <= 768) return;
				if (target.classList.contains("banner-box")) {
					target.classList.remove("opacity-0");
					target.classList.add("animate__fadeIn");
				} else {
					target.classList.add("animate__fadeInLeft");
				}
			},
			(target) => {
				if (window.innerWidth <= 768) return;
				if (target.classList.contains("banner-box")) {
					target.classList.remove("animate__fadeIn");
					target.classList.add("opacity-0");
				} else {
					target.classList.remove("animate__fadeInLeft");
				}
			},
		);
	}, []);
	return (
		<div className={`absolute inset-0 z-[3] bg-transparent `} style={style}>
			<div className="c-flex container h-full w-full max-lg:mt-[80px] max-md:mt-[160px] max-md:px-0">
				<div className="home-banner mb-[350px] ml-[750px] flex w-full max-2xl:mb-[250px] max-2xl:ml-[450px] max-xl:mb-[100px] max-xl:ml-[300px]  max-lg:mb-[300px] max-lg:ml-[180px]   ">
					{/* font-serif */}
					<div className=" animate  animate__animated  banner-box animate__delay-300 max- max-md:ml-6 max-md:w-full max-md:py-[25px] max-md:shadow-none md:ml-[220px] md:mt-[150px]">
						<h2 className=" animate__animated animate animate__delay-800 py-1 text-[60px] leading-[60px]  text-white max-xl:text-[45px]  max-lg:text-[40px] max-lg:leading-[40px] max-md:hidden max-md:font-poppins max-md:text-xl ">
							{t("hb1")}
							<br></br> {t("hb2")}
						</h2>
						<h2 className="bannerBtn animate__animated animate animate__delay-1000 !mb-[4px] py-1.5 text-[20px] font-light  text-white max-lg:hidden max-md:hidden max-md:text-sm ">
							{t("hb3")}
						</h2>
						<Link
							href={"/products"}
							className="bannerBtn animate animate__animated animate__delay-1500 mt-8 block w-fit border-[1px] border-white  bg-opacity-0 px-4 py-2 text-[22px] text-white duration-300 hover:!text-gray-300   max-lg:mt-4 max-md:mt-2 max-md:hidden max-md:text-sm"
						>
							{t("Show More")}
						</Link>
					</div>
					{/* <div className="ml-[300px] flex ">
						<LoadNormalModal
							setHover={setHover}
							modalUrl={"/stary3D/" + "xinghe-1000w-6-4us.glb"} // 传递 ArrayBuffer 给 View3DModal
							className={`mb-[300px] ml-[300px]  !h-[380px] !w-[500px] rounded-lg  max-2xl:ml-[200px] max-xl:ml-[50px] max-md:!h-[450px]`}
							fileName={"xinghe-1000w-6-4us.glb"}
							metalness={0.8}
							roughness={0.2}
							color={"#161417"}
						/>
						<div className="mt-[230px]  ">
							<img src="/image/home/3dmark.svg" className="fill-opacity=0.5 h-[35px] w-[35px]" alt="" />
						</div>
					</div> */}
				</div>
			</div>
		</div>
	);
};

const MobileCard = ({
	title,
	desc,
	link,
	desc2,
	desc3,
	style = {}, // 默认样式为空
}: CardType) => {
	const t = useTranslations("banner");

	return (
		<div className="absolute inset-0 z-[3] flex flex-col items-center" style={style}>
			<div className="container mt-[80px] p-6 text-center">
				<div className="animate animate__animated animate__fadeIn animate__delay-300 mb-8">
					<h2 className="animate animate__animated animate__fadeIn animate__delay-500 text-shadow-md mb-2 font-poppins text-[30px] font-extrabold leading-[36px] tracking-wide text-white">
						{t("hb1")}
						<br /> {t("hb2")}
					</h2>
					<h3 className="animate animate__animated animate__fadeIn animate__delay-700 text-shadow-sm mb-6 text-[18px] font-semibold tracking-wide text-white">
						{t("hb3")}
					</h3>
					<Link
						href={"/products"}
						className="animate animate__animated animate__fadeIn animate__delay-900 inline-block border-[1.5px] border-white bg-black bg-opacity-20 px-5 py-2 text-[16px] font-medium tracking-wide text-white shadow-md duration-300 hover:text-gray-300"
					>
						{t("Show More")}
					</Link>
				</div>
			</div>
		</div>
	);
};

const Banner1 = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className="relative h-full w-full bg-white max-md:hidden">
			<img src={"/image/home/banner/Banner2.webp"} className="h-full w-full object-cover" alt="Banner" />
			<Card {...cardData} setHover={setHover} />
		</div>
	);
};

const MBanner = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className="relative h-full w-full bg-white md:hidden">
			<img src={"/image/home/banner/mb1.webp"} className="h-full w-full object-cover" alt="Mobile Banner" />
			{/* <MobileCard {...cardData} /> */}
			<div className="absolute left-0 right-[430px] top-[200px] max-2xl:right-[300px] max-lg:right-[200px] max-lg:top-[100px] 2xl:top-[200px] 3xl:right-[430px] 3xl:top-[250px] 4xl:right-[450px] 4xl:top-[350px] ">
				<div className="flex flex-col items-center justify-center">
					<div className="flex items-center justify-center">
						<h2 className="text-[80px] font-extrabold tracking-wide text-white max-2xl:text-[50px] max-lg:text-[30px]">
							Stary Line
						</h2>
					</div>
					<h5 className="text-[34px] font-normal tracking-wide text-white max-2xl:text-[24px] max-lg:text-[14px]">
						Power Bank Anywhere
					</h5>
				</div>
			</div>
		</div>
	);
};

const MBanner2 = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className="relative h-full w-full bg-white md:hidden">
			<img src={"/image/home/banner/mb2.webp"} className="h-full w-full object-cover" alt="Mobile Banner" />
			{/* <MobileCard {...cardData} /> */}
		</div>
	);
};

const MBanner3 = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className="relative h-full w-full bg-white md:hidden">
			<img src={"/image/home/banner/mb3.webp"} className="h-full w-full object-cover" alt="Mobile Banner" />
			{/* <MobileCard {...cardData} /> */}
			<div className="absolute left-0 right-[430px] top-[200px] max-2xl:right-[300px] max-lg:right-[-170px] max-lg:top-[100px] 2xl:top-[200px] 3xl:right-[430px] 3xl:top-[250px] 4xl:right-[450px] 4xl:top-[350px] ">
				<div className="flex flex-col items-center justify-center">
					<div className="flex items-center justify-center">
						<h2 className="text-[80px] font-extrabold tracking-wide text-white max-2xl:text-[50px] max-lg:text-[30px]">
							Stary Line
						</h2>
					</div>
					<h5 className="text-[34px] font-normal tracking-wide text-white max-2xl:text-[24px] max-lg:text-[14px]">
						Power Bank Anywhere
					</h5>
				</div>
			</div>
		</div>
	);
};
const MBanner4 = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className="relative h-full w-full bg-white md:hidden">
			<img src={"/image/home/banner/mb44.webp"} className="h-full w-full object-cover" alt="Mobile Banner" />
			{/* <MobileCard {...cardData} /> */}
			<div className="absolute left-0 right-[430px] top-[200px] max-2xl:right-[300px] max-lg:right-[-170px] max-lg:top-[100px] 2xl:top-[200px] 3xl:right-[430px] 3xl:top-[250px] 4xl:right-[450px] 4xl:top-[350px] ">
				<div className="flex flex-col items-center justify-center">
					<div className="flex items-center justify-center">
						<h2 className="text-[80px] font-extrabold tracking-wide text-white max-2xl:text-[50px] max-lg:text-[30px]">
							Stary Line
						</h2>
					</div>
					<h5 className="text-[34px] font-normal tracking-wide text-white max-2xl:text-[24px] max-lg:text-[14px]">
						Power Bank Anywhere
					</h5>
				</div>
			</div>
		</div>
	);
};
const Banner2 = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className="relative h-full w-full bg-white pt-[62px] max-md:hidden">
			<img src={"/image/home/banner/Banner.webp"} className="h-full w-full object-cover" alt="Banner" />
			{/* <Card {...cardData} setHover={setHover} /> */}
			<div className="absolute left-0 right-[430px] top-[200px] max-2xl:right-[300px] max-lg:right-[200px] max-lg:top-[150px] 2xl:top-[200px] 3xl:right-[430px] 3xl:top-[250px] 4xl:right-[450px] 4xl:top-[350px] ">
				<div className="flex flex-col items-center justify-center">
					<div className="flex items-center justify-center">
						<h2 className="text-[80px] font-extrabold tracking-wide text-white max-2xl:text-[50px] max-lg:text-[30px]">
							Stary Line
						</h2>
					</div>
					<h5 className="text-[34px] font-normal tracking-wide text-white max-2xl:text-[24px] max-lg:text-[14px]">
						Power Bank Anywhere
					</h5>
				</div>
			</div>
		</div>
	);
};
const Banner3 = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className={`b-flex relative h-full w-full bg-white max-md:hidden max-md:!h-auto max-md:flex-col `}>
			{/* <video
				src="/image/home/banner2.mp4"
				autoPlay
				muted
				loop
				playsInline
				style={{ width: "100%", height: "auto" }}
				className={`${hover ? "blur-sm" : ""} transition-all  duration-500 `}
			/> */}
			<video
				src={"/image/home/yun.mp4"}
				autoPlay
				muted
				loop
				playsInline
				className="absolute inset-0 w-full object-cover max-md:!h-auto"
			/>

			<img
				src={"/image/home/beijing.webp"}
				className="z-[2]  w-full object-cover  max-md:!h-auto md:mt-[40px]"
				alt="BG.webp"
			/>
			<Card2 {...cardData} setHover={setHover} />
		</div>
	);
};
const Banner4 = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className="relative h-full w-full bg-white  max-md:hidden">
			<img src={"/image/home/banner/banner3.webp"} className="h-full w-full object-cover" alt="Banner" />
			{/* <Card {...cardData} setHover={setHover} /> */}
		</div>
	);
};
const Banner5 = () => {
	const [hover, setHover] = useState(false);

	const cardData = {
		title: "11YEARS",
		desc: "PACKAGING",
		desc2: "ISA",
		desc3: "OUR PRODUCTS",
		link: "/products",
	};
	return (
		<div className="relative h-full w-full bg-white  max-md:hidden">
			<img src={"/image/home/banner/banner4444.webp"} className="h-full w-full object-cover" alt="Banner" />
			{/* <Card {...cardData} setHover={setHover} /> */}
		</div>
	);
};
function HomeBanner() {
	return (
		<div className="banner">
			<Swiper
				modules={[Navigation, Autoplay]}
				className="home-banner group mb-[80px] h-full  max-md:mb-5"
				spaceBetween={spaceBetween}
				slidesPerView={slidesPerView}
				navigation={true}
				loop={true}
				pagination={{
					clickable: true,
					bulletActiveClass: "swiper-pagination-bullet-active !bg-white",
					bulletClass: "swiper-pagination-bullet home-banner-bullet",
				}}
				autoplay={{
					delay: 5000,
					disableOnInteraction: true,
				}}
			>
				<SwiperSlide className="h-full">
					<Banner2 />
					<MBanner />
				</SwiperSlide>
				<SwiperSlide className="">
					<Banner3 />
					<MBanner2 />
				</SwiperSlide>
				<SwiperSlide className="">
					<Banner4 />
					<MBanner3 />
				</SwiperSlide>
				<SwiperSlide className="">
					<Banner5 />
					<MBanner4 />
				</SwiperSlide>
			</Swiper>
		</div>
	);
}
export default React.memo(HomeBanner);
